import styled, { css } from 'styled-components';
import { Drawer } from 'react-rainbow-components';
import ButtonIcon from 'components/ButtonIcon';
import Input from 'components/Input';
import LoadingShape from 'components/LoadingShape';
import {
    DIVIDER,
    GREY_300,
    GREY_400,
    GREY_50,
    GREY_800,
    HIGHLIGHT,
    PURPLE_100,
} from '../../../constants';

export const StyledDrawer = styled(Drawer)`
    border-radius: 1.5rem;
    margin: 1.5rem;
    box-sizing: border-box;
    width: 380px;
    min-width: 380px;
    height: calc(100% - 3rem);
    min-height: calc(100% - 3rem);
    max-height: calc(100% - 3rem);
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.07);

    > div {
        box-sizing: border-box;
    }

    > div[id^="drawer-content"] {
        padding: 0.5rem 0 0;
        margin: 0 0 1rem;
    }
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
    margin: 1rem 1rem 0;
    padding-bottom: 1rem;
    border-bottom: 1px solid ${DIVIDER};
    position: relative;
`;

export const Title = styled.h2`
    display: flex;
    align-items: center;
    height: 3rem;
    font-size: 1.25rem;
    font-weight: 800;
    line-height: 1.75rem;
    color: ${GREY_800};
`;

export const CloseButton = styled(ButtonIcon)`
    position: absolute;
    right: 0;
    top: 0;
    color: ${GREY_800};

    & svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }
`;

export const SearchInput = styled(Input)`
    width: 100%;

    span {
        left: 1rem;
    }

    svg {
        width: 1.5rem !important;
        height: 1.5rem !important;
        font-size: 1.5rem !important;
    }

    input {
        background: ${GREY_50};
        border-color: ${GREY_50};
        height: 3rem;
        line-height: 3rem;
        padding: 0px 1rem 0px 3rem;

        &:focus {
            padding-left: 2.9375rem;
        }
    }
`;

export const Group = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 0.5rem;
`;

export const GroupTitle = styled.div`
    padding: 0.5rem 1.5rem;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${GREY_300};
    text-transform: uppercase;
`;

export const PatientButton = styled.button<{ isSelected?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 0.625rem;
    width: 100%;
    padding: 1rem 1.5rem;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;

    &:hover {
        background: ${HIGHLIGHT};
    }

    ${(props) => props.isSelected && css`
        background: ${PURPLE_100};

        &:hover {
            background: ${PURPLE_100};
        }
    `}
`;

export const PatientInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    align-self: stretch;
`;

export const PatientNameRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
`;

export const PatientName = styled.h4`
    font-size: 0.9375rem;
    font-weight: 500;
    line-height: 1.375rem;
    color: ${GREY_800};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const PatientDetails = styled.p`
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${GREY_400};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const PatientBadges = styled.div`
    display: flex;
    align-items: center;
    gap: 0.25rem;
    flex-shrink: 0;
`;

export const EmptyText = styled.p`
    padding: 0.5rem 1.5rem;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.25rem;
    color: ${GREY_400};
`;

export const SkeletonItem = styled.div`
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1rem 1.5rem;
`;

export const SkeletonAvatar = styled(LoadingShape)`
    margin: 0;
    flex-shrink: 0;
`;

export const SkeletonLines = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
`;

export const LoadMoreContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: 0.5rem 1.5rem;
`;

export const Footer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
`;
